import styles from "./EditNotesDialog.module.css";
import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import GlobalMessage from "../../GlobalMessage";
import LoadingMsgBar from "../../LoadingMsgBar";
import NotesService from "../../../Services/NotesService";

function EditNotesDialog({ open, note, onNoteSaved, onClose }) {
  const [noteText, setNoteText] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [noteTextError, setNoteTextError] = useState("");
  
  // Initialize note text when dialog opens or note changes
  useEffect(() => {
    if (note?.noteText) {
      setNoteText(note.noteText);
    }
  }, [note]);

  // Validate form and return true if valid
  const validateForm = () => {
    if (!noteText.trim()) {
      setNoteTextError("Note is required.");
      return false;
    }

    setNoteTextError("");
    
    return true;
  };

  const handleSave = async () => {
    if (validateForm()) {
      try {
        setIsSaving(true);
        setErrorMessage("");
        await NotesService.updateNote(note.userNoteId, noteText);
        onClose();
        setTimeout(() => {
          onNoteSaved(note, noteText);
        }, 10); // Notify parent of change after updates are complete to avoid update unmounted component errro
      } catch (error) {
        console.error("Error updating note:", error);
        setErrorMessage("Error updating note. Please try again later.");
      } finally {
        setIsSaving(false);
      }
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      className={styles.dialog}
      fullWidth
      aria-labelledby="edit-note-dialog-title"
    >
      <DialogTitle id="edit-note-dialog-title">Edit Note</DialogTitle>
      
      <DialogContent>
        {isSaving && <LoadingMsgBar loadMsg="Saving note..." />}
        {errorMessage && <GlobalMessage message={errorMessage} type="error" />}
        
        <TextField
          autoFocus
          label="Note"
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          error={!!noteTextError}
          helperText={noteTextError}
          multiline
          minRows={4}
          inputProps={{ maxLength: 1000 }}
          fullWidth
          required
          placeholder="Enter your note here..."
          margin="normal"
        />
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={handleSave} 
          color="primary" 
          variant="contained"
          disabled={isSaving}
        >
          Save
        </Button>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { EditNotesDialog };
